export default __webpack_public_path__ + "static/media/mens-fashion.70058ce9.jpeg";